import Vue from "vue";
import "./registerServiceWorker";
import App from "./App.vue";
import router from "./router"; // Make sure this path is correct
import Vuetify from "vuetify"; // Import Vuetify
import "vuetify/dist/vuetify.min.css"; // Import Vuetify CSS

Vue.config.productionTip = false;

Vue.use(Vuetify); // Use Vuetify

new Vue({
  vuetify: new Vuetify({
    theme: {
      themes: {
        light: {
          primary: "#6a3399",
          secondary: "#ba86fc",
          accent: "#ff4081",
          error: "#ff5252",
          info: "#2196f3",
          success: "#4caf50",
          warning: "#fb8c00",
        },
      },
    },
  }), // Add Vuetify instance here with theme
  router, // Add the router here
  render: (h) => h(App),
}).$mount("#app");
